import { Button, DropDownList, IDataView, Input, Tables } from '@ixyberfree/ixybercomponents';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useStores } from '../../../store';
import { ICLStruct } from '../IConfiguration';

interface IPropsTypePage {
    num_type: number;
}

const TypePage = ({ num_type }: IPropsTypePage): JSX.Element => {
    const { ICLibStore } = useStores();

    const ChangeName = (name: string) => {
        let newState = { ...val };
        newState.name = name;
        ICLibStore.updateType(num_type, newState);
    };

    const ChangeType = (type: string) => {
        let newState = { ...val, data: { ...val.data, type: type } };
        ICLibStore.updateType(num_type, newState);
    };

    const val = ICLibStore.configLib().itypes.variables[num_type];

    const ModeTypes: IDataView[] = [
        { id: 'array', value: 'array' },
        { id: 'enum', value: 'enum' },
        { id: 'struct', value: 'struct' }
    ];

    const selected = ModeTypes.find((item) => item.id === val.data.type) || { id: '', value: '' };

    return (
        <React.Fragment>
            Имя:{' '}
            <Input
                type="text"
                style={{ width: '250px' }}
                defaultValue={val.name}
                onBlur={(event) => ChangeName(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.currentTarget.blur();
                    }
                }}
            />
            Механизм создания типа:
            <DropDownList
                type="text"
                style={{ width: '100%' }}
                data={ModeTypes}
                selected={selected}
                width="250px"
                onElementClick={(event) => {
                    const item = event.target as HTMLElement;
                    const itemId = item.getAttribute('itemId');
                    if (itemId) ChangeType(itemId);
                }}
            />
            Информация о типе:
            {val.data.type == 'array' ? <RenderArray num_type={num_type} /> : ''}
            {val.data.type == 'enum' ? <RenderEnums num_type={num_type} /> : ''}
            {val.data.type == 'struct' ? <RenderStruct num_type={num_type} /> : ''}
        </React.Fragment>
    );
};

const RenderArray = observer((props: IPropsTypePage) => {
    const { ICLibStore } = useStores();

    const val = ICLibStore.configLib().itypes.variables[props.num_type];

    const ChangeBaseType = (newType: string) => {
        let propsTemp = { ...val };
        if (propsTemp.data.array == null) propsTemp.data.array = {};
        propsTemp.data.array.baseType = newType;
        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const ChangeDefValueType = (new_value: string) => {
        let propsTemp = { ...val };
        if (propsTemp.data.array == null) propsTemp.data.array = {};
        propsTemp.data.array.initVal = new_value;
        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const ChangeLength = (new_length: number) => {
        let propsTemp = { ...val };
        if (propsTemp.data.array == null) propsTemp.data.array = {};
        if (propsTemp.data.array.vars == null) propsTemp.data.array.vars = [];

        let len = propsTemp.data.array.vars.length;
        if (len >= new_length) {
            propsTemp.data.array.vars = propsTemp.data.array.vars.slice(0, new_length);
        } else {
            for (let i = len; i < new_length; i++) {
                propsTemp.data.array.vars.push(0);
            }
        }

        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const ChangeArraySize = (i: number, size: number) => {
        let propsTemp = { ...val };
        if (propsTemp.data?.array?.vars != null) {
            propsTemp.data.array.vars[i] = size;
        }
        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const selected = ICLibStore.systemTypeSelect.find((item) => item.id === val.data.array?.baseType) || {
        id: '',
        value: ''
    };

    return (
        <React.Fragment>
            <div>
                Базовый тип:{' '}
                <DropDownList
                    type="text"
                    style={{ width: '100%' }}
                    data={ICLibStore.systemTypeSelect}
                    selected={selected}
                    width="100%"
                    onClick={(event) => {
                        const item = event.target as HTMLElement;
                        const itemId = item.getAttribute('itemId');
                        if (itemId) ChangeBaseType(itemId);
                    }}
                />
            </div>
            <div>
                Исходное значение:{' '}
                <Input
                    type="text"
                    defaultValue={val.data.array?.initVal}
                    onBlur={(event) => {
                        ChangeDefValueType(event.target.value);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.currentTarget.blur();
                        }
                    }}
                />
            </div>
            <div>
                Кол-во строк:{' '}
                <Input
                    type="number"
                    defaultValue={val.data.array?.vars?.length.toString()}
                    onBlur={(event) => {
                        ChangeLength(Number(event.target.value));
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.currentTarget.blur();
                        }
                    }}
                />
            </div>
            <div>
                <div style={{ float: 'left' }}>Размеры: </div>
                {val.data.array?.vars?.map((object, i) => (
                    <div style={{ float: 'left' }}>
                        <Input
                            type="number"
                            width="50px"
                            defaultValue={object.toString()}
                            onBlur={(event) => {
                                ChangeArraySize(i, Number(event.target.value));
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.currentTarget.blur();
                                }
                            }}
                        />
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
});

const RenderEnums = observer((props: IPropsTypePage) => {
    const { ICLibStore } = useStores();

    const val = ICLibStore.configLib().itypes.variables[props.num_type];

    const ChangeLength = (new_length: number) => {
        let propsTemp = { ...val };
        if (propsTemp.data.enums == null) propsTemp.data.enums = {};
        if (propsTemp.data.enums.vars == null) propsTemp.data.enums.vars = [];

        let len = propsTemp.data.enums.vars.length;
        if (len >= new_length) {
            propsTemp.data.enums.vars = propsTemp.data.enums.vars.slice(0, new_length);
        } else {
            for (let i = len; i < new_length; i++) {
                propsTemp.data.enums.vars.push({ val: '', init: i.toString() });
            }
        }

        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const ChangeArrayValue = (i: number, text: string) => {
        let propsTemp = { ...val };
        if (propsTemp.data?.enums?.vars != null) {
            propsTemp.data.enums.vars[i].val = text;
        }
        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const ChangeArrayValueInit = (i: number, text: string) => {
        let propsTemp = { ...val };
        if (propsTemp.data?.enums?.vars != null) {
            propsTemp.data.enums.vars[i].init = text;
        }
        ICLibStore.updateType(props.num_type, propsTemp);
    };

    const ChangeDefValueType = (text: string) => {
        let propsTemp = { ...val };
        if (propsTemp.data?.enums == null) {
            propsTemp.data.enums = { initVal: '' };
        }
        propsTemp.data.enums.initVal = text;
        ICLibStore.updateType(props.num_type, propsTemp);
    };

    return (
        <React.Fragment>
            <div>
                Исходное значение:{' '}
                <Input
                    type="text"
                    defaultValue={val.data.enums?.initVal}
                    onBlur={(event) => ChangeDefValueType(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.currentTarget.blur();
                        }
                    }}
                />
            </div>
            <div>
                Размер перечисления:{' '}
                <Input
                    type="number"
                    defaultValue={val.data.enums?.vars?.length.toString()}
                    onBlur={(e) => {
                        ChangeLength(Number(e.currentTarget.value));
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.currentTarget.blur();
                        }
                    }}
                />
            </div>
            <div>
                <div style={{}}>Значения: </div>
                {val.data.enums?.vars?.map((object, i) => (
                    <div>
                        <div style={{ display: 'inline-block' }}>
                            <Input
                                type="text"
                                width="100px"
                                defaultValue={object.init}
                                onBlur={(e) => {
                                    ChangeArrayValueInit(i, e.target.value);
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        event.currentTarget.blur();
                                    }
                                }}
                            />
                        </div>
                        <div style={{ display: 'inline-block' }}>
                            <Input
                                type="text"
                                width="250px"
                                defaultValue={object.val}
                                onBlur={(e) => {
                                    ChangeArrayValue(i, e.target.value);
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        event.currentTarget.blur();
                                    }
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
});

const RenderStruct = observer((props: IPropsTypePage) => {
    const { ICLibStore } = useStores();

    const val = ICLibStore.configLib().itypes.variables[props.num_type];

    let sstruct = val.data.struct;

    const FindNameProps = (id: number = 0, name: string = 'Props'): string => {
        let fName = name;
        if (val.data.struct) {
            let elIndex = val.data.struct.findIndex((f) => f.name.toLowerCase() == name.toLowerCase());
            if (elIndex != id && elIndex > -1) {
                let maxProps = 10000;
                for (let i = 0; i < maxProps; i++) {
                    let newName = name + '_' + i;
                    elIndex = val.data.struct.findIndex((f) => f.name.toLowerCase() == newName.toLowerCase());
                    if (elIndex == -1) {
                        fName = newName;
                        break;
                    }
                }
            }
        }
        return fName;
    };

    const DellAttr = (id: number) => {
        let propsTemp = { ...val };
        if (sstruct) {
            if (sstruct.length > id) {
                propsTemp.data.struct?.splice(id, 1);
                ICLibStore.updateType(props.num_type, propsTemp);
            }
        }
    };

    const ChangeName = (id: number, name: string) => {
        let propsTemp = { ...val };
        if (name != '' && name != null) {
            if (propsTemp.data.struct != null) {
                if (propsTemp.data.struct.length == id) {
                    propsTemp.data.struct.push({ name: name, type: ICLibStore.systemTypesDefault[0] });
                }

                if (id < propsTemp.data.struct.length) {
                    let nName = FindNameProps(id, name);
                    propsTemp.data.struct[id].name = nName;
                    ICLibStore.updateType(props.num_type, propsTemp);
                }
            }
        }
    };

    const ChangeDefValueType = (id: number, text: string) => {
        let propsTemp = { ...val };
        if (sstruct) {
            if (sstruct.length > id) {
                if (propsTemp.data.struct != null) propsTemp.data.struct[id].initVal = text;
                ICLibStore.updateType(props.num_type, propsTemp);
            }
        }
    };

    const ChangeTypeAttr = (id: number, typeName: string) => {
        let propsTemp = { ...val };
        if (sstruct) {
            if (sstruct.length > id) {
                if (propsTemp.data.struct != null) propsTemp.data.struct[id].type = typeName;
                ICLibStore.updateType(props.num_type, propsTemp);
            }
        }
    };

    const renderRow = (item: ICLStruct, i: number) => {
        const selected = ICLibStore.systemTypeSelect.find((items) => items.id === item.type) || {
            id: '',
            value: ''
        };
        return {
            name: (
                <div onClick={(e) => e.stopPropagation()}>
                    <Input
                        key={'name' + item.name + i}
                        id={'name' + item.name + i}
                        type="text"
                        defaultValue={item.name}
                        onBlur={(event) => {
                            ChangeName(i, event.target.value);
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.currentTarget.blur();
                            }
                        }}
                    />
                </div>
            ),
            type: (
                <div onClick={(e) => e.stopPropagation()}>
                    <DropDownList
                        type={'text'}
                        // style={{ width: '100px' }}
                        key={'type' + item.name + i}
                        data={ICLibStore.systemTypeSelect}
                        selected={selected}
                        width="100%"
                        onClick={(event) => {
                            const item = event.target as HTMLElement;
                            const itemId = item.getAttribute('itemId');
                            if (itemId) ChangeTypeAttr(i, itemId);
                        }}
                    />
                </div>
            ),
            initVal: (
                <div onClick={(e) => e.stopPropagation()}>
                    <Input
                        key={'initVal' + item.name + i}
                        id={'initVal' + item.name + i}
                        type="text"
                        defaultValue={item.initVal}
                        onBlur={(event) => {
                            ChangeDefValueType(i, event.target.value);
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.currentTarget.blur();
                            }
                        }}
                    />
                </div>
            ),
            buttoncol: (
                <div>
                    <Button key={'buttoncol' + item.name + i} text="У" onClick={() => DellAttr(i)} />
                </div>
            )
        };
    };

    return (
        <React.Fragment>
            <div>
                <Tables
                    key={'variables' + props.num_type}
                    width="720px"
                    height="500px"
                    header={[
                        { type: 'text', label: 'Имя', width: '200px', idCol: 'name' },
                        { type: 'text', label: 'Тип', width: '200px', idCol: 'type' },
                        { type: 'text', label: 'Исходное значение', width: '200px', idCol: 'initVal' },
                        { type: 'text', label: '', width: '100px', idCol: 'buttoncol' }
                    ]}
                    data={
                        sstruct
                            ? sstruct
                                  .map((item, i) => renderRow(item, i))
                                  .concat(renderRow({ name: '', type: '' }, sstruct.length))
                            : []
                    }
                />
            </div>
        </React.Fragment>
    );
});

export default observer(TypePage);

//<Reports startFilterName={'fromValue'} startFilterVal={'OFF'} filterListCol={['userID']} />
